import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Popover } from '@mui/material';
import { useState } from 'react';

import './MoreDialog.less';

export type MoreDialogItem = {
  label?: string;
  action?: () => void;
  icon?: React.JSX.Element;
  /**
   * default: when null is 'all'
   */
  location?: 'dropdown-menu' | 'hover-menu';
} | null;

type MoreDialogProps = {
  items?: MoreDialogItem[];
};

const MoreDialog = (props: MoreDialogProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  return (
    <>
      {/* Dots button */}
      <button
        type="button"
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
        className="more-dialog-dots"
      >
        <MoreVertIcon sx={{ fontSize: '20px' }} />
      </button>

      {/* Popover box */}
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {!!props?.items && (
          <div className="more-dialog-popper">
            {props.items
              ?.filter((i) => (i?.location === undefined || i?.location === 'dropdown-menu') && !!i)
              ?.map((item, idx) => (
                <button
                  key={`more_modal_${idx.toString()}`}
                  type="button"
                  onClick={() => {
                    setAnchorEl(null);
                    item?.action?.();
                  }}
                  className="more-dialog-item"
                >
                  {item?.icon}
                  <p>{item?.label}</p>
                </button>
              ))}
          </div>
        )}
      </Popover>
    </>
  );
};

export default MoreDialog;
